export const FilterBrokerageEnum = {
  my_company: 'my_company',
  exclude: 'exclude',
  filter: 'filter',
}

export const FilterBrokerageLabels = {
  [FilterBrokerageEnum.my_company]: 'My Company',
  [FilterBrokerageEnum.exclude]: 'Exclude Brokerage',
  [FilterBrokerageEnum.filter]: 'Brokerage Only',
}

export const FilterBrokerageItems = Object.keys(FilterBrokerageEnum).map(key => ({
  text: FilterBrokerageLabels[key],
  value: FilterBrokerageEnum[key],
}));
